import React from 'react';
import { Link } from 'react-router-dom';
import { Home, CheckSquare, Brain, ClipboardList, ImageIcon, Briefcase, Plane, Menu } from 'lucide-react';

interface BottomNavProps {
  currentPath: string;
  onOpenMenu: () => void;
}

export function BottomNav({ currentPath, onOpenMenu }: BottomNavProps) {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-black border-t border-gray-800 md:hidden z-[9999] px-4 h-19.5">
      <nav className="flex items-center h-full max-w-7xl mx-auto py-3">
        <div className="flex-1 flex justify-center gap-8">
        <Link
          to="/"
          className={`p-1 flex flex-col items-center ${
            currentPath === '/' ? 'text-[var(--accent-color)]' : 'text-white'
          }`}
        >
          <Home className="w-6 h-6" />
        </Link>
        <Link
          to="/lists"
          className={`p-1 flex flex-col items-center ${
            currentPath === '/lists' ? 'text-[var(--accent-color)]' : 'text-white'
          }`}
        >
          <ClipboardList className="w-6 h-6" />
        </Link>
        <Link
          to="/tasks"
          className={`p-1 flex flex-col items-center ${
            currentPath === '/tasks' ? 'text-[var(--accent-color)]' : 'text-white'
          }`}
        >
          <CheckSquare className="w-6 h-6" />
        </Link>
        <Link
          to="/brain-dump"
          className={`p-1 flex flex-col items-center ${
            currentPath === '/brain-dump' ? 'text-[var(--accent-color)]' : 'text-white'
          }`}
        >
          <Brain className="w-6 h-6" />
        </Link>
        <Link
          to="/travel"
          className={`p-1 flex flex-col items-center ${
            currentPath === '/travel' ? 'text-[var(--accent-color)]' : 'text-white'
          }`}
        >
          <Plane className="w-6 h-6" />
        </Link>
        </div>
        <button
          onClick={onOpenMenu}
          className="p-1 flex flex-col items-center text-white ml-4"
        >
          <Menu className="w-6 h-6" />
        </button>
      </nav>
    </div>
  );
}